import { useTranslation } from 'react-i18next';
import React, {useCallback,} from 'react';
import {
  Button, 
  TextField, 
  Dialog, 
  DialogActions, 
  DialogContent, 
  DialogTitle,
  Grid
} from '@mui/material';
export default function DetailsBox(props) {
  const {open, onClose, title, details, onBtnKlick} = props;
  const {t} = useTranslation();
  const drawButtons = () => {
    return(
      <>
        <Button onClick={() => onClose()} color="primary">
          {t("Zurück")}
        </Button>
      </>
    )
  }
  const inputBoxFragen = useCallback(
    () => {
      var alleFragen = null;
      alleFragen = details?.map((element, count) => {
        var frageElement = ""
        if (element.button === "1") {
          if (element?.link) {
            frageElement=
            <Grid item xs={12} key={"key"+count.toString()}>
            <Button
              type="button"
              color="primary"
              type="submit"
              fullWidth
              target="_blank"
              variant="outlined"
              rel="noopener noreferrer"
              href={"http://"+element.link}
            >{element.bez}
          </Button>
          </Grid>
          } else {
          frageElement=
          <Grid item xs={12} key={"key"+count.toString()}>
            <Button 
              onClick={() => onBtnKlick(element.wert)} 
              color="primary"
              variant="outlined"
              fullWidth              
            >
            {element.bez}
            </Button>
          </Grid>
          }
        } else {
          frageElement=
            <Grid item xs={12} key={"key"+count.toString()}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                variant="outlined"
                label={element.bez}
                value={element.wert}
                multiline rows={element?.rows?element.rows:"1"}
                fullWidth
              />
            </Grid>
      }
       return(frageElement);
      });
      return(alleFragen);
    },
    [details,],
  )
  return (
      <Dialog
        open={open}
        fullWidth
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            {inputBoxFragen()}
          </Grid>
        </DialogContent>
        <DialogActions>
          {drawButtons()}
        </DialogActions>
      </Dialog>
  );
}
